import { deviceShowState } from '@/store/deviceInfo'
import AgoraRTC from 'agora-rtc-sdk-ng'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import Modal from '../Modal'

export default () => {
  const [state, setState] = useState(false)
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    listenDeviceChange()
    return () => {
      // 设备监听清除
      AgoraRTC.onCameraChanged = () => {}
      AgoraRTC.onMicrophoneChanged = () => {}
      AgoraRTC.onPlaybackDeviceChanged = () => {}
    }
  }, [])
  // 设备变化检测提醒
  const listenDeviceChange = () => {
    AgoraRTC.onCameraChanged = deviceChange
    AgoraRTC.onMicrophoneChanged = deviceChange
    AgoraRTC.onPlaybackDeviceChanged = deviceChange
  }
  const deviceChange = useCallback(() => {
    setState(true)
  }, [])

  return (
    <Modal
      show={state}
      cancel={() => {
        setState(false)
      }}
      header=""
      confirm={() => {
        setState(false)
        if (location.pathname === '/room') {
          navigate('/center')
        } else {
          setDeviceShow(true)
        }
      }}
      cancelText="暂不检测"
      confirmText={location.pathname === '/room' ? '退出教室' : '开始检测'}
    >
      <div className="mx-auto my-[20px] w-[300px]">{location.pathname === '/room' ? '检测到您的设备有变化，需退出教室重新设备检测' : '检测到您的设备有变化，需重新设备检测'}</div>
    </Modal>
  )
}
